import {CLEAR_STATE} from "../types";
import {replace} from 'react-router-redux';
import call from './call';

export default () => async (dispatch) =>
{
    const onResult= (result) =>
    {
        dispatch({type:CLEAR_STATE});
        dispatch(replace('/'));
    }
    dispatch(call("LoginService/logoutUser",{},onResult));
};